Controller.$inject = [];

function Controller() {
    const self = this;
}

export function HuiIcon() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            color: '@',
            sizing: '@',
            shape: '@',
            type: '@?',
            variant: '@'
        },
        transclude: true,
        controller: Controller,
        controllerAs: '$huiCtrl',
        template: ($element, $attrs) => {
            let tag;
            switch ($attrs.type) {
                case 'button':
                    tag = 'button';
                    break;
                case 'link':
                    tag = 'a';
                    break;
                default:
                    tag = 'div';
                    break;
            }

            return `<${tag} class="hui hui-icon"
                         ng-class="[
                         'hui-' + ($huiCtrl.color|| 'accent'),
                         $huiCtrl.sizing || 'md',
                          $huiCtrl.variant || 'solid', 
                         $huiCtrl.shape || 'circle']
                         ">
                   <ng-transclude></ng-transclude>
             </${tag}>`
        }
    }
}